import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-141" data-mp="2av1rs2qqff0o">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-142" data-mp="38ap5aq9nnyae">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-143" data-mp="335doxspz4ru7">
            <div className="hidden shrink-0 text-left sm:block" data-id="element-144" data-mp="2pbmp5c21ombo">
              <p className="text-xs text-white/60 line-through" data-id="element-145" data-mp="2uapmsbfp3q9m">$166</p>
              <p className="font-serif text-2xl font-black leading-none text-gold" data-id="element-146" data-mp="2fdyh5kffhibk">$27</p>
            </div>
            <a href={CHECKOUT_URL} className="animate-cta-shake flex flex-1 items-center justify-center gap-2 rounded-xl bg-cta px-4 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(22,163,74,0.8)] transition-colors duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-gold sm:text-base" data-id="element-147" data-mp="2kctavhexorag">
              <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-148" data-mp="9jyrfef7iprt" />
              <span data-id="element-149" data-mp="76ll0xa8unlp">Get it now for $27</span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}